import { useSplitterProgressContext } from "@/components/pages/stem-splitter/components/providers/stem-splitter-progress-provider";
import { useCancelProcess } from "@/hooks/use-cancel-process";

export const useCancelSplit = () => {
  const progressContext = useSplitterProgressContext();

  const { cancelProcess, isLoading } = useCancelProcess(
    "/api/split/cancel?",
    new URLSearchParams({
      //if cancel button is visible, then it is guaranteed that splitId is not undefined
      split_id: progressContext.processId!,
    }),
    () => progressContext.forceCancelCurrentProcess(),
  );

  return { cancelSplit: cancelProcess, isCancelling: isLoading };
};
